/**
 * CustomEditWrapper — thin wrapper around Volto's Edit component.
 *
 * Checks config.settings.customEditors for the current content type.
 * If a custom editor is registered, renders it instead of the stock Edit.
 * Otherwise, renders Volto's original Edit component unchanged.
 *
 * Registered as an addonRoute on the /edit paths, which takes priority
 * over Volto's default route. This avoids shadowing/customizing Edit.jsx.
 */
import React from 'react';
import { useSelector } from 'react-redux';
import Edit from '@plone/volto/components/manage/Edit/Edit';
import config from '@plone/volto/registry';

const CustomEditWrapper = (props) => {
  const contentType = useSelector((state) => state.content?.data?.['@type']);

  const customEditors = config.settings.customEditors || {};
  const CustomEditor = contentType && customEditors[contentType];

  if (CustomEditor) {
    return <CustomEditor {...props} />;
  }

  return <Edit {...props} />;
};

export default CustomEditWrapper;
